import React from 'react'
import BidAuctionCarousel from '@components/BidAuctionCarousel/BidAuctionCarousel'
import Section from '@components/ItemPage/Layout/Section'

const RelatedAuctions = ({ relatedAuctions }: { relatedAuctions: any }) => {
  if (!relatedAuctions) return <></>

  return (
    <div className="bg-white w-full">
      <div className="mobile-padding px-4">
        <Section title="Related Auctions">
          <BidAuctionCarousel auctions={relatedAuctions} isItemDetail />
        </Section>
      </div>
    </div>
  )
}

export default RelatedAuctions
